import debug from 'bows';

export function emptyLinks() {
	const log   = debug('links:emptyLinks');
	const links = Array.prototype.slice.call(document.querySelectorAll('a[href=""], a[href="#"]'));

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			log('empty link not followed', link);
		});
	});
	log(`There are ${links.length} empty links on this page`, links);
}

export function externalLinks() {
	const log    = debug('links:externalLinks');
	const links = Array.prototype.slice.call(document.querySelectorAll('a[href]:not([target])')).filter((link, i) => {
		const href     = link.href.trim();
		const isEmpty  = href === '';
		const isLocal  = href.indexOf(document.location.origin) === 0;
		const isAnchor = href.indexOf('#') === 0;

		if (isEmpty || isLocal || isAnchor) {
			return false;
		}

		return true;
	});

	links.forEach((link) => {
		link.target = '_blank';
		link.rel = ( link.rel ) ? link.rel + ' noopener' : 'noopener';
	});

	log(`There are ${links.length} external links on this page`, links);
}

export default {
	emptyLinks   : emptyLinks,
	externalLinks: externalLinks
};
